import React from 'react';

import { CancellationFeeConfirmModalProps } from 'components/Modals/CancellationFeeConfirmModal/types';
import { CancellationFeePaymentModalProps } from 'components/Modals/CancellationFeePaymentModal/types';
import { ICancellationReasonModal } from 'components/Modals/CancellationReasonModal/types';
import { ConfirmCancelWorkoutProps } from 'components/Modals/ConfirmCancellationModalContainer/ConfirmCancellationModalContainer';
import { IDiscountOfferModal } from 'components/Modals/DiscountOfferModal/types';
import { ErrorModalProps } from 'components/Modals/ErrorModal/types';
import { ErrorModalWithPaymentProps } from 'components/Modals/ErrorModalWithPayment/types';
import { IFeedbackFormModal } from 'components/Modals/FeedbackFormContainer/types';
import { PauseSubscriptionModalProps } from 'components/Modals/PauseSubscriptionModal/types';
import { PlanSuggestionOfferModalProps } from 'components/Modals/PlanSuggestionOfferModal/types';
import { WorkoutReasonAbandonProps } from 'components/Modals/ReasonAbandonModal';
import { ReminderOfferModalProps } from 'components/Modals/ReminderOfferModal/types';
import { ReminderSuccessModalProps } from 'components/Modals/ReminderSuccessModal/types';
import { IRestoreSubscriptionModal } from 'components/Modals/RestoreSubscriptionModal/types';
import { UniversalModalProps } from 'components/Modals/UniversalModal';
import { VideoInstructionModalProps } from 'components/Modals/VideoInstructionModal';
import { IWaitingModal } from 'components/Modals/WaitingModal/types';

export enum ModalName {
    feedbackForm = 'feedbackForm',
    confirmCancelWorkout = 'confirmCancelWorkout',
    workoutReasonAbandon = 'workoutReasonAbandon',
    videoInstructionModal = 'videoInstructionModal',
    cancellationReasonModal = 'cancellationReasonModal',
    planSuggestion = 'planSuggestion',
    discountOfferModal = 'discountOfferModal',
    waitingModal = 'waitingModal',
    universalModal = 'universalModal',
    restoreSubscriptionModal = 'restoreSubscriptionModal',
    pauseSubscriptionModal = 'pauseSubscriptionModal',
    reminderOfferModal = 'reminderOfferModal',
    reminderSuccessModal = 'reminderSuccessModal',
    errorModal = 'errorModal',
    feeAlert = 'feeAlert',
    feePayment = 'feePayment',
    errorModalWithPayment = 'errorModalWithPayment',
}

export type ModalPropsType = {
    [ModalName.feedbackForm]: IFeedbackFormModal;
    [ModalName.confirmCancelWorkout]: ConfirmCancelWorkoutProps;
    [ModalName.workoutReasonAbandon]: WorkoutReasonAbandonProps;
    [ModalName.universalModal]: UniversalModalProps;
    [ModalName.videoInstructionModal]: VideoInstructionModalProps;
    [ModalName.cancellationReasonModal]: ICancellationReasonModal;
    [ModalName.planSuggestion]: PlanSuggestionOfferModalProps;
    [ModalName.discountOfferModal]: IDiscountOfferModal;
    [ModalName.pauseSubscriptionModal]: PauseSubscriptionModalProps;
    [ModalName.waitingModal]: IWaitingModal;
    [ModalName.restoreSubscriptionModal]: IRestoreSubscriptionModal;
    [ModalName.reminderOfferModal]: ReminderOfferModalProps;
    [ModalName.reminderSuccessModal]: ReminderSuccessModalProps;
    [ModalName.errorModal]: ErrorModalProps;
    [ModalName.errorModalWithPayment]: ErrorModalWithPaymentProps;
    [ModalName.feeAlert]: CancellationFeeConfirmModalProps;
    [ModalName.feePayment]: CancellationFeePaymentModalProps;
};

export type ModalsMapType = {
    [key in ModalName]: React.ComponentType<ModalPropsType[key]>;
};
